import FormatterLayout from './component';

export default FormatterLayout;
